'use client';

import { AnimationContainer } from '@/components/ui/animation-container';
import { CheckCircle } from 'lucide-react';
import type { TranslationKeys } from '../translations';

interface TrustBadgesProps {
  t: TranslationKeys;
}

export default function TrustBadges({ t }: TrustBadgesProps) {
  return (
      <section className="py-3 px-4">
          <div className="max-w-4xl mx-auto">
            <div className="flex flex-wrap justify-center gap-x-10 gap-y-4 text-sm text-gray-600">
              {[
                { label: t.uscis },
                { label: t.ata },
                { label: t.soc2 },
                { label: t.hipaa },
              ].map((badge, index) => (
                <AnimationContainer
                  key={index}
                  delay={index * 0.1}
                >
                  <div className="flex items-center gap-2">
                    <CheckCircle className="w-5 h-5 text-green-500" />
                    <span>{badge.label}</span>
                  </div>
                </AnimationContainer>
              ))}
            </div>
          </div>
      </section>
  );
}
